
































































import Vue from 'vue';
import Page from '@/components/Page.vue'
import store, {InvoiceParamStore} from '../services/store';
import InvoiceParams from '../models/sysinvoice';
import { t } from "@/plugins/i18n";


interface Data{
  store: InvoiceParamStore;
}

interface Computed{
  invoiceParams: InvoiceParams[];
  invoiceParamCols: any[];
}

export default Vue.extend<Data, {},Computed,{}>({
  components:{Page},


  data() {
    return {
      store,
    }
  },


  methods:{
    editInvoiceParam(invoiceParamToEditID: number){
        this.$router.push("/invoice-parameter/"+invoiceParamToEditID)
    }
  },


  computed: {
    invoiceParams() {
      return this.store.invoiceParams;
    },
    invoiceParamCols() {
      return [
        {
          title: t("BelsoKod"),
          field: "code",
        },
        {
          title: t("Prefix"),
          field: "prefix",
        },
        {
          title: t("InvoiceParametering_Szamlatipus"),
          field: "name",
        },
        {
          title: t("NevIdNyelven"),
          field: "foreign",
        },
        {
          title: t("NevAngolul"),
          field: "english",
        },
        {
          title: t("InvoiceParametering_ElolegElhatFokSz"),
          field: "separAccCode",
        },
        {
          title: t("AfaFokSzam"),
          field: "vatAccCode",
        },
        {
          title: t("InvoiceParametering_SCALASzlaSzam"),
          field: "scalaAccInvNo",
        },
        {
          title: t("InvoiceParametering_FSzlaNAtfuto"),
          field: "isNoCuracc",
          type:"boolean",
          cell: "isNoCuraccTemp"
        },
        {
          title: t("InvoiceParametering_AlapeFszNemAtf"),
          field: "defNoCuracc",
          type: "boolean",
          cell: "defNoCuraccTemp"
        },
        {
          title: t("InvoiceParametering_ArbevetelKontir"),
          field: "isAccCont",
          type: "boolean",
          cell: "isAccContTemp"
        },
        {
          title: t("InvoiceParametering_Elo"),
          field: "deleted",
          type: "boolean",
          cell: "deletedTemp"
        },
        {
          cell: "editTemp", 
          width:50
        }

      ]
    },
  },


  beforeMount(){
    this.store.setInvoiceParams();
  },



})

